import React from 'react';
import PriceMatrixRow from 'shared/components/price/PriceMatrixRow';

const PriceMatrixBody = (props) => {
  const { quantities } = props;

  return (
    <tbody>
      {quantities.map((qty, row) => (
        <PriceMatrixRow
          key={row}
          quantity={qty}
          row={row}
          {...props} />
      ))}
    </tbody>
  );
};

export default PriceMatrixBody;
